import React from "react";
import { Marker, useMap } from "react-map-gl/maplibre";
import styled from "styled-components";

import { createComponent } from "@opendash/state";

import { MarkerType } from "../types";

const MarkerDiv = styled.div<{ active: boolean }>`
  background-color: ${(p) =>
    p.active
      ? "var(--ant-primary-color)"
      : "var(--ant-primary-color-disabled)"};
  width: 3rem;
  height: 3rem;
  display: block;
  left: -1.5rem;
  top: -1.5rem;
  position: relative;
  border-radius: 3rem 3rem 0;
  transform: rotate(45deg);
  border: 1px solid var(--ant-primary-color);
`;

interface Props {
  places: MarkerType[];
  selection?: MarkerType[];
  onSelection(checked: MarkerType[]): void;
}

export const MapMarkerCluster = createComponent<Props>(
  function MapMarkerCluster({ places, selection = [], onSelection }) {
    const { current: map } = useMap();

    return (
      <>
        {places.map((place) => (
          <Marker
            key={place.key}
            latitude={place.latitude}
            longitude={place.longitude}
            anchor="bottom"
          >
            <MarkerDiv
              active={selection.includes(place)}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();

                if (selection.includes(place)) {
                  onSelection(selection.filter((p) => p !== place));
                } else {
                  onSelection([...selection, place]);
                }
              }}
            />
          </Marker>
        ))}
      </>
    );
  }
);
